// extracted by mini-css-extract-plugin
export default {"container":"AcceptInvite_container__gdUFa","spinner":"AcceptInvite_spinner__JViXU","mutedText":"AcceptInvite_mutedText__rq90p","smallMuted":"AcceptInvite_smallMuted__BzJlr"};